import React, { Component } from 'react';

class Depositesolde extends Component {
    render() {
        return (
            <div className="deposite__solde text-center mb-2" style={{color : this.props.win || this.props.lose}}>
                {this.props.win && (<span className='mr-2'>+</span>)}
                {this.props.lose && (<span className='mr-2'>-</span>)}
                <span className='mr-2'>{this.props.solde}</span><span>DZD</span>
            </div>
        );
    }
}

export default Depositesolde;
